<template>
  <div id="app">
    <div v-if="!isIPAuthorized">
      <p v-if="isRendingFinished">
        Your ip {{ip}} is not authorized, please contact administrator.
      </p>
    </div>
    <div v-if="isIPAuthorized" class="app">
      <b-navbar
        v-if="!maintaining || (maintaining && user.name == 'Rick') "
        toggleable="lg"
        class=" navbar-expand-lg navbar-dark"
        :variant="navbarVariant"
        sticky
      >
        <b-navbar-brand>JohnStonemart</b-navbar-brand>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item" v-if="isAuthenticated && user.name != 'Operator1'">
              <b-dropdown size="sm" id="dropdown-1" text="" class="m-md-2" :variant="changeSystemButtonVariant">
                <b-dropdown-item class="m-0 p-0" variant="success" @click="changeSystem('crm')">CRM</b-dropdown-item>
                <b-dropdown-item variant="primary" @click="changeSystem('installation')">Installation</b-dropdown-item>
              </b-dropdown>
            </li>
            <li class="nav-item">
              <b-nav-item-dropdown
                toggle-class="nav-link-custom"
                v-if="isAuthenticated && system == 'installation' && user.name != 'Operator1'"
                text="Installation"
              >
                <b-dropdown-item @click="changeView('Events')"
                  >Events</b-dropdown-item
                >
                <hr class="m-1" />
                <b-dropdown-item @click="changeView('Calendar')"
                  >Calendar</b-dropdown-item
                >
                <hr class="m-1" />
                <b-dropdown-item @click="changeView('Manual')"
                  >Manual</b-dropdown-item
                >
              </b-nav-item-dropdown>
            </li>
            <li v-if="this.user.role != 'worker'" class="nav-item">
              <a
                class="nav-link text-white pointer"
                v-if="isAuthenticated && (system == 'crm') && user.name != 'Operator1'"
                @click="changeView('CRMOrders')"
                >
                <strong>Orders</strong>
              </a>
            </li>
            <li class="nav-item" v-if="this.user.role != 'worker'">

              <b-nav-item-dropdown
                toggle-class="nav-link-custom"
                v-if="isAuthenticated && (system == 'crm') && user.name != 'Operator1'"
                text="Quotation"
              >
                <b-dropdown-item @click="changeView('Quotes')"
                  >Table</b-dropdown-item
                >
                <hr class="m-1" />
                <b-dropdown-item @click="changeView('QuoteCalendar')"
                  >Calendar Table</b-dropdown-item
                >
              </b-nav-item-dropdown>
            </li>
            <li class="nav-item" v-if="this.user.role != 'worker'">
              <b-nav-item-dropdown
                toggle-class="nav-link-custom"
                v-if="isAuthenticated && (system == 'crm') && user.name != 'Operator1'"
                text="Appointment"
              >
                <b-dropdown-item @click="changeView('Bookings')"
                  >Table</b-dropdown-item
                >
                <hr class="m-1" />
                <b-dropdown-item @click="changeView('BookingCalendar')"
                  >Calendar Table</b-dropdown-item
                >
              </b-nav-item-dropdown>
            </li>

            <li v-if="this.user.role != 'worker'" class="nav-item">
              <a
                class="nav-link text-white pointer"
                v-if="isAuthenticated && (system == 'crm') && user.name != 'Operator1'"
                @click="changeView('DailyReports')"
                ><strong>Daily Reports</strong></a
              >
            </li>

            <li v-if="this.user.role != 'worker'" class="nav-item">
              <b-nav-item-dropdown
                toggle-class="nav-link-custom"
                v-if="isAuthenticated && (system == 'crm')"
                text="Follow Up"
              >
                <!-- <b-dropdown-item @click="changeView('DailyReports')">Daily Reports</b-dropdown-item>
                <hr class="m-1"> -->
                <b-dropdown-item @click="changeView('FollowUpReports')"
                  >Follow Up Reports</b-dropdown-item
                >
                <hr class="m-1" />
                <b-dropdown-item @click="changeView('AdditionalInscription')"
                  >Additional Inscription</b-dropdown-item
                >
              </b-nav-item-dropdown>
            </li>

            <li v-if="isAuthenticated && this.user.role == 'admin'" class="nav-item">
              <a
                class="nav-link text-white pointer"
                v-if="isAuthenticated && system == 'installation' && user.name != 'Operator1'"
                @click="changeView('AccessoryOrders')"
                ><strong>Accessory Orders</strong>
              </a>
            </li>

            <li class="nav-item">
              <!-- <a
                class="nav-link text-white pointer"
                v-if="isAuthenticated && this.user.role == 'admin' && system == 'installation' && user.name != 'Operator1'"
                @click="changeView('InventoryHome')"
                >
                <strong>Inventory</strong>
              </a> -->
              <b-nav-item-dropdown
                toggle-class="nav-link-custom"
                v-if="isAuthenticated && this.user.role == 'admin' && system == 'installation' && user.name != 'Operator1'"
                text="Inventory"
              >
                <b-dropdown-item @click="changeView('InventoryManagement')"
                  >Management</b-dropdown-item
                >
                <hr class="m-1" />
                <b-dropdown-item @click="changeView('InventoryStockIn')"
                  >Stock In</b-dropdown-item
                >
                <hr class="m-1" />
                <b-dropdown-item @click="changeView('InventoryStockOut')"
                  >Stock Out</b-dropdown-item
                >
              </b-nav-item-dropdown>
            </li>

            <li class="nav-item">
              <a
                class="nav-link text-white pointer"
                v-if="isAuthenticated && this.user.role == 'admin' && system == 'installation' && user.name != 'Operator1'"
                @click="changeView('Management')"
                ><strong> Management </strong></a
              >
            </li>

            <li class="nav-item" v-if="this.user.role != 'worker'">
              <b-nav-item-dropdown
                toggle-class="nav-link-custom"
                v-if="isAuthenticated && system == 'crm' && user.name != 'Operator1'"
                text="Forms"
              >
                <b-dropdown-item @click="changeView('CustomerFeedback')"
                  >Customer Feedback</b-dropdown-item
                >
                <hr class="m-1" />
                <b-dropdown-item @click="changeView('DeliveryDocket')"
                  >Delivery Docket</b-dropdown-item
                >
              </b-nav-item-dropdown>
            </li>

            <li class="nav-item">
              <a
                class="nav-link text-white pointer"
                v-if="isAuthenticated && this.user.role != 'worker' && system == 'crm' && user.name != 'Operator1'"
                @click="changeView('Drive')"
                ><strong> Drive </strong></a
              >
            </li>

            <li class="nav-item">
              <a
                class="nav-link text-white pointer"
                v-if="!isAuthenticated"
                @click="changeView('Login')"
                ><strong> Login </strong></a
              >
            </li>
          </ul>
          <a class="nav-link text-white bold" href="http://54.153.162.30/"
            >Database</a>
          <p style="color: white">{{ version }}</p>
          <a class="nav-link text-white" v-if="isAuthenticated">
            <strong> Hi {{ this.user.name }} </strong>
            <div
              class="admin-badge text-primary text-center"
              v-if="user.role == 'admin'"
            >
              Admin
            </div>
          </a>
          <b-button
            class="nav-link text-white pointer"
            size="sm"
            variant="danger"
            v-if="isAuthenticated"
            @click="logout()"
            ><strong> Log out </strong></b-button
          >
        </div>
      </b-navbar>

      <div class="container-fluid py-2">
        <component
          id="“component”"
          v-bind:crmOrdersFilterCriteria="crmOrdersFilterCriteria"
          v-on:changeCrmOrdersFilterCriteria="changeCrmOrdersFilterCriteria($event)"
          v-bind:user="user"
          v-bind:is="component"
          v-bind:selectedEvent="selectedEvent"
          v-bind:exportEvent="exportEvent"
          v-bind:exportAccessoryOrder="exportAccessoryOrder"
          v-bind:newTaskType="newTaskType"
          v-bind:selectedInscriptionId="selectedInscriptionId"
          v-bind:from="from"
          v-bind:globalCurrentPage="globalCurrentPage"
          v-bind:filterInfo="filterInfo"
          v-bind:quote="selectedQuote"
          v-bind:new_quote_type="new_quote_type"
          v-bind:givenQuote="editedQuote"
          v-bind:crmViewedOrderId="viewedOrderId"
          v-bind:CRMOrder="CRMOrder"
          v-bind:today="today"
          v-bind:dataLists="dataLists"
          v-bind:selectOptions="selectOptions"
          v-bind:sales="sales"
          v-bind:CRMAdvancedSearchInfo="CRMAdvancedSearchInfo"
          v-on:resetOrderId="resetOrderId"
          v-on:CRMAdvancedSearchInfo="UpdateCRMAdvancedSearchInfo($event)"
          v-on:crmAddSmallTask="crmAddSmallTask($event)"
          v-on:crmAddInstallation="crmAddInstallation($event)"
          v-on:showEventDetails="showEventDetails($event)"
          v-on:showInscriptionDetails="showInscriptionDetails($event)"
          v-on:authentication="authentication($event)"
          v-on:updateUserInfo="updateUserInfo($event)"
          v-on:addEvent="changeView('AddEvent')"
          v-on:backTo="changeView($event)"
          v-on:backToAccessoryOrders="changeView('AccessoryOrders')"
          v-on:backToInscriptions="changeView($event)"
          v-on:exportEvent="outputEvent($event)"
          v-on:exportAccessoryOrder="outputAccessoryOrder($event)"
          v-on:addSmallTask="addSmallTask()"
          v-on:addInstallation="addInstallation()"
          v-on:addInscription="addInscription()"
          v-on:backToEventDetail="backToEventDetail($event)"
          v-on:changeGlobalPage="changeGlobalPage($event)"
          v-on:changeFilterInfo="changeFilterInfo($event)"
          v-on:createQuote="createQuote($event)"
          v-on:viewQuote="viewQuote($event)"
          v-on:editQuote="editQuote($event)"
          v-on:chooseSystem="chooseSystem($event)"
          v-on:CRMViewOrder="crmViewOrder($event)"
          v-on:CRMAddMonumentQuote="crmAddMonumentQuote($event)"
          v-on:CRMAddAdditionalInscriptionQuote="crmAddAdditionalInscriptionQuote($event)"
          v-on:ResetCRMOrder="resetCRMOrder()"
          v-on:ChangeSystem="changeSystem($event)"
        />
      </div>

      <b-alert
        class="my-alert"
        :show="dismissCountDown"
        @dismissed="dismissCountDown = -1"
        @dismiss-count-down="countDownChanged"
        dismissible
      >
        Default Alert
        <b-progress
          variant="info"
          :max="dismissSecs - 1"
          :value="dismissCountDown - 1"
          height="4px"
        ></b-progress>
      </b-alert>
    </div>
  </div>
</template>

<script>
import AddEvent from "./views/AddEvent";
import Calendar from "./views/EventCalendar";
import EventDetails from "./views/EventDetails";
import Events from "./views/Events";
import ExportEvent from "./views/ExportEvent";
import Inscriptions from "./views/Inscriptions";
import InscriptionDetails from "./views/InscriptionDetails";
import Login from "./views/Login";
import Management from "./views/Management";
import Manual from "./views/Manual";
import Quotes from "./views/Quotes";
import CreateQuote from "./views/CreateQuote";
import QuoteCalendar from "./views/QuoteCalendar";
import ExportQuote from "./views/ExportQuote";
import Bookings from "./views/Bookings";
import BookingCalendar from "./views/BookingCalendar.vue";
import DailyReports from "./views/DailyReports.vue";
import FollowUpReports from "./views/FollowUpReports.vue";
import AdditionalInscription from "./views/AdditionalInscription.vue";
import EditQuote from "./views/EditQuote.vue";
import InscBookings from "./views/InscBookings.vue";
import AccessoryOrders from "./views/AccessoryOrders.vue";
import InventoryStockOut from "./views/Inventory/InventoryStockOut.vue";
import InventoryStockIn from "./views/Inventory/InventoryStockIn.vue"
import InventoryManagement from "./views/Inventory/InventoryManagement.vue";
import AccessoryOrderExport from "./views/AccessoryOrderExport.vue";
import ChooseSystem from "./views/ChooseSystem.vue";
import CRMOrders from './views/CRM/CRMOrders.vue';
import CRMOrderDetails from './views/CRM/CRMOrderDetails.vue';
import CustomerFeedback from "./views/Forms/CustomerFeedback.vue";
import DeliveryDocket from "./views/Forms/DeliveryDocket.vue";
import Drive from "./views/CRM/Drive.vue"
import InventoryHome from "./views/Inventory/InventoryHome.vue"

import { version } from '../package.json';
import firebase from "firebase/app";
import MaintainingPage from './views/MaintainingPage.vue';

export default {
  data() {
    return {
      version: "",
      maintaining: false,
      CRMAdvancedSearchInfo: {
        advanced_search_result: [], 
        advanced_filter_criteria_invoice_number: "",
        advanced_filter_criteria_sales: "",
        advanced_filter_criteria_customer_name: "",
        advanced_filter_criteria_style: "",
        advanced_filter_criteria_cemetery: "",
        advanced_filter_criteria_section: "",
        advanced_filter_criteria_row: "",
        advanced_filter_criteria_grave: "",
        advanced_filter_criteria_container: "",
        searchMode: "",
      },
      selectOptions: {
        cemeteries: [],
        foundations: ['', 'Done by Cemetery', 'Done by Steve', 'Need Foundation', 'Additional Inscriptions'],
        funeralServiceProviderNames: [],
        inscriptionToFactoryOptions: ['Yes', 'No'],
        installer_names: ['Mark', 'John', 'Peter', 'Michael', 'Sam', 'Paul Zhang', 'Ziggy', ''],
        jobStyles: [],
        leadSourceNames: [],
        manufacturerNames: ['LY', 'DS', 'Wuzhiping', 'Jialilai', ''],
        salesNames: [],
        storeLocationNames: [],
        accessortStatuses: ["arrived", "processing"],
        frameColorOptions: ["silver", "black"],
        perspexColorOptions: ["clear", "black"],
      },
      dataLists: {
        suburbList: [],
        sectionList: [],
      },
      today: "",
      crmOrdersFilterCriteria: "",
      CRMOrder: null,
      viewedOrderId: "",
      changeSystemButtonVariant: "",
      navbarVariant: "primary",
      system: "",
      ip: "",
      dismissCountDown: 0,
      dismissSecs: 4,
      isRendingFinished: false,
      isAuthenticated: false,
      user: {
        email: "",
        username: "",
        role: "",
      },
      globalCurrentPage: 1,
      filterInfo: {
        filterForm_filterKeyword: "",
        filterForm_filterOn: "all",
      },
      component: "Login",
      selectedEvent: Object,
      selectedInscriptionId: "",
      isIPAuthorized: false,
      exportEvent: null,
      exportAccessoryOrder: null,
      newTaskType: "",
      from: "",
      selectedQuote: Object,
      new_quote_type: "",
      editedQuote: Object,
    };
  },
  components: {
    MaintainingPage,
    InventoryHome,
    CRMOrderDetails,
    CRMOrders,
    Events,
    EventDetails,
    Login,
    AddEvent,
    Management,
    ExportEvent,
    Inscriptions,
    InscriptionDetails,
    Manual,
    Calendar,
    Quotes,
    CreateQuote,
    QuoteCalendar,
    ExportQuote,
    Bookings,
    BookingCalendar,
    DailyReports,
    FollowUpReports,
    AdditionalInscription,
    EditQuote,
    InscBookings,
    InventoryStockOut,
    InventoryManagement,
    InventoryStockIn,
    AccessoryOrders,
    AccessoryOrderExport,
    ChooseSystem,
    CustomerFeedback,
    DeliveryDocket,
    Drive
  },
  created() {
    this.version = version;
    firebase
      .firestore()
      .collection("parameters")
      .doc("version")
      .get()
      .then((doc) => {
        if (doc.data().version > version) {
          location.reload(true);
        }
      });

    fetch("https://api.ipify.org?format=json")
      .then((x) => x.json())
      .then(({ ip }) => {
        this.ip = ip;
        firebase
          .firestore()
          .collection("ip")
          .onSnapshot((collection) => {
            var iPs = collection.docs.map((doc) => doc.data());
            for (var i = 0; i < iPs.length; i++) {
              if (iPs[i].ip == ip) {
                this.isIPAuthorized = true;
                break;
              }
            }
            this.isRendingFinished = true;
          });
      });

    // firebase.auth().onAuthStateChanged((snapshot) => {
    //   if (snapshot) {
    //     this.isAuthenticated = true;
    //   } else {
    //     this.isAuthenticated = false;
    //     console.log("unauthenticated");
    //   }
    // });

    firebase
      .firestore()
      .collection("datalists")
      .onSnapshot((collection) => {
        const lists = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < lists.length; i++) {
          if (lists[i].name == 'suburbList') {
            this.dataLists.suburbList = lists[i].suburbList;
          }
          if (lists[i].name == 'sectionList') {
            this.dataLists.sectionList = lists[i].sectionList;
          }
        }
      });

    firebase
      .firestore()
      .collection("saless")
      .onSnapshot((collection) => {
        this.sales = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < this.sales.length; i++) {
          this.selectOptions.salesNames.push(this.sales[i].name);
        }
      });

    firebase
      .firestore()
      .collection("lead_sources")
      .orderBy("name")
      .onSnapshot((collection) => {
        this.leadSources = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < this.leadSources.length; i++) {
          this.selectOptions.leadSourceNames.push(this.leadSources[i].name);
        }
      });

    firebase
      .firestore()
      .collection('store_locations')
      .orderBy('name')
      .onSnapshot((collection) => {
      this.storeLocations = collection.docs.map(doc => doc.data());
      for (var i = 0; i < this.storeLocations.length; i++) {
        this.selectOptions.storeLocationNames.push(this.storeLocations[i].name);
      }
    });

    firebase
      .firestore()
      .collection("funeral_providers")
      .orderBy("name")
      .onSnapshot((collection) => {
        this.funeralServiceProviders = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < this.funeralServiceProviders.length; i++) {
        this.selectOptions.funeralServiceProviderNames.push(this.funeralServiceProviders[i].name);
      }
      });

    firebase
      .firestore()
      .collection('job_styles')
      .orderBy('name')
      .onSnapshot((collection) => {
        const job_style_objs = collection.docs.map(doc => doc.data());
        for (var i = 0; i < job_style_objs.length; i++) {
          this.selectOptions.jobStyles.push(job_style_objs[i].name);
        }
    });

    firebase
      .firestore()
      .collection('cemeteries')
      .orderBy('name')
      .onSnapshot((collection) => {
      const cemeterie_objs = collection.docs.map(doc => doc.data());
      for (var i = 0; i < cemeterie_objs.length; i++) {
        this.selectOptions.cemeteries.push(cemeterie_objs[i].name);
      }
    });

    firebase
      .firestore()
      .collection("parameters")
      .doc("system_info")
      .onSnapshot((data) => {
      this.maintaining = data.data().maintaining;
    });

    const now = new Date();
    const dd = String(now.getDate()).padStart(2, "0");
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const yyyy = now.getFullYear();
    this.today = yyyy + "-" + mm + "-" + dd;
  },
  watch: {
    maintaining(newMaintaining, oldMaintaining) {
      if (this.isAuthenticated == false) {
        return;
      }

      if (oldMaintaining == true && newMaintaining == false) {
        location.reload(true);
      } else if (oldMaintaining == false && newMaintaining == true && this.user.name != "Rick") {
        this.component = "MaintainingPage";
      }
    },
    async isAuthenticated(newIsAuthenticated) {
      console.log(this.isAuthenticated);
      console.log("authentication testing");

      var self = this;

      const system_info_snapshot = await firebase.firestore().collection("parameters").doc("system_info").get()
      this.maintaining = system_info_snapshot.data().maintaining;
      if (this.maintaining && this.user.name != "Rick") {
        this.component = "MaintainingPage";
        return;
      }

      if (!newIsAuthenticated) {
        this.changeView("Login");
        this.user = {};
      } else {
        var usersRef = firebase.firestore().collection("users");
        var userId = firebase.auth().currentUser.uid;
        var docRef = usersRef.doc(userId);
        docRef
          .get()
          .then((doc) => {
            if (doc) {
              self.user = doc.data();
              if (self.user.name != 'Rick') {
                if ( self.user.name == 'Operator1') {
                  self.component = "FollowUpReports";
                } else {
                  self.component = 'ChooseSystem';
                }
              } else {
                self.component = 'ChooseSystem';
              }
              
            } else {
              console.log("No such document!");
            }
          })
          .catch((error) => {
            console.log("Error getting document", error);
          });
      }
    }
    ,
  },
  methods: {
    UpdateCRMAdvancedSearchInfo(item) {
      this.CRMAdvancedSearchInfo = item;
    },
    changeCrmOrdersFilterCriteria(criteria) {
      this.crmOrdersFilterCriteria = criteria;
    },  
    resetOrderId() {
      this.CRMOrder = null;
    },
    changeSystem(system_name) {
      this.system = system_name;
      if (system_name == 'installation') {
        this.changeSystemButtonVariant = "success";
        this.navbarVariant = "primary";
        this.component = 'Events';
      } else {
        this.changeSystemButtonVariant = "primary"
        this.navbarVariant = "success";
        this.component = 'CRMOrders';
      }
    },
    chooseSystem(system_name) {
      this.system = system_name;
      if (system_name == 'installation') {
        this.changeSystemButtonVariant = "success"
        this.navbarVariant = "primary";
        this.component = 'Events';
      } else {
        this.changeSystemButtonVariant = "primary"
        this.navbarVariant = "success";
        this.component = 'CRMOrders';
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    changeGlobalPage(newPage) {
      this.globalCurrentPage = newPage;
    },
    changeFilterInfo(newFilterInfo) {
      this.filterInfo = newFilterInfo;
    },
    logout: function() {
      this.system = "";
      firebase.auth().signOut();
      this.isAuthenticated = false;
      this.component = "Login"
    },
    authentication: function(result) {
      this.isAuthenticated = result;
    },
    updateUserInfo: function(user) {
      this.user = user;
    },
    changeView: function(view) {
      this.component = view;
    },
    addEvent() {
      this.component = "AddEvent";
    },
    showEventDetails(event) {
      this.selectedEvent = event.event;
      this.from = event.from;
      if (event.globalCurrentPage) this.globalCurrentPage = event.currentPage;
      if (event.filterInfo) this.filterInfo = event.filterInfo;
      this.changeView("EventDetails");
    },
    showInscriptionDetails(event) {
      this.selectedInscriptionId = event;
      this.changeView("InscriptionDetails");
    },
    outputEvent(event) {
      this.component = "exportEvent";
      this.exportEvent = event;
    },
    outputAccessoryOrder(event) {
      this.component = "AccessoryOrderExport";
      this.exportAccessoryOrder = event;
    },
    addSmallTask() {
      this.from="Events";
      this.component = "AddEvent";
      this.newTaskType = "small task";
    },
    addInstallation() {
      this.from="Events";
      this.component = "AddEvent";
      this.newTaskType = "installation";
    },
    addInscription() {
      this.component = "AddEvent";
      this.newTaskType = "inscription";
    },
    backToEventDetail(event) {
      this.selectedEvent = event;
      this.changeView("EventDetails");
    },
    createQuote(type) {
      this.component = "CreateQuote";
      this.new_quote_type = type;
    },
    viewQuote(event) {
      this.selectedQuote = event.quote;
      this.from = event.from;
      //this.viewedOrder;
      this.changeView("ExportQuote");
    },
    editQuote(event) {
      this.editedQuote = event.quote;
      this.changeView("EditQuote");
    },
    crmViewOrder(item) {
      // console.log(item.item);
      this.viewedOrderId = item.id;
      this.from = item.from;
      this.changeSystem('crm');
      this.changeView("CRMOrderDetails");
    },
    crmAddSmallTask(order) {
      this.CRMOrder = order;
      this.from = "CRMOrderDetails"
      this.newTaskType = "small task";
      this.component = "AddEvent";
    },
    crmAddInstallation(order) {
      this.CRMOrder = order;
      this.from = "CRMOrderDetails"
      this.newTaskType = "installation";
      this.component = "AddEvent";
    },
    crmAddMonumentQuote(order) {
      this.CRMOrder = order;
      this.from = "CRMOrderDetails"
      this.new_quote_type = 'monument';
      this.component = "CreateQuote";
    },
    crmAddAdditionalInscriptionQuote(order) {
      this.CRMOrder = order;
      this.from = "CRMOrderDetails"
      this.new_quote_type = 'inscription';
      this.component = "CreateQuote";
    },
    resetCRMOrder() {
      this.CRMOrder == null;
    }
  },
};
</script>

<style>
@page {size: auto !important}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
}

.pointer {
  cursor: pointer;
}

.admin-badge {
  background: white;
  border-radius: 5px;
  margin-right: auto;
  padding: 0 10px;
  font-weight: bold;
}

#app .my-alert {
  position: fixed;
  text-align: center;
  margin-left: -250px;
  top: 100px;
  left: 50%;
  width: 500px;
}

.nav-link-custom {
  color: white !important;
  font-weight: bold;
}
</style>
